import { AuthMethods } from "@/lib/consts/auth";
import { AuthError } from "@/lib/types/error";
import { HttpErrorCodes } from "@/lib/types/http";
import { languageService } from "@/lib/services/language";

export interface AuthErrorData {
    authMethod: AuthMethods;
    errorCode: number;
    errorMessage: string;
    enrichedMessage?: string;
}

export const isAuthError = (error: unknown): error is AuthError => {
    return typeof error === 'object' && error !== null && 'code' in error && 'message' in error;
}

export const getAuthErrorData = (error: unknown, authMethod: AuthMethods): AuthErrorData | undefined => {
    if (!error || typeof error !== 'object') return undefined;

    const err = error as Record<string, unknown>;
    let errorCode: number | undefined;
    let enrichedMessage: string | undefined;

    if (typeof err.code === 'number') {
        errorCode = err.code;
        enrichedMessage = typeof err.enrichedMessage === 'string' ? err.enrichedMessage : undefined;
    } else if (typeof err.errorCode === 'number') {
        errorCode = err.errorCode;
    } else if (typeof err.status === 'number' && err.status > 0) {
        errorCode = err.status;
    }

    if (errorCode === undefined) return undefined;

    const errorMessage = errorCode >= HttpErrorCodes.INTERNAL_SERVER_ERROR
        ? languageService.translate('login.errorMessages.serviceIsDown')
        : languageService.translate('login.errorMessages.loginFailed');

    return { authMethod, errorCode, errorMessage, enrichedMessage };
}